import styled from 'styled-components'

import { themeStyles } from '../../../styles/theme'
import { brandConfig } from '../../../config/brandConfig'
import Link from '../../atoms/link'

export const StyledSlide = styled(Link)`
  position: relative;
  display: flex;
  flex-direction: column;
  color: ${themeStyles.colors.white.main};
  text-decoration: none;

  &:hover .pm-icon-right {
    opacity: 1;
  }

  .pm-icon-right {
    margin-left: auto;
    width: 0.9em;
    height: 0.9em;
    transition: 0.3s opacity;

    opacity: 0;
  }
`

const fadeSize = '2em'
export const StyledGradientContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 1em;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  margin-top: -${parseFloat(fadeSize)}em;
  padding-top: ${fadeSize};
  padding-bottom: 0.5em;
  position: relative;

  background: ${themeStyles.colors.darkGreys[4].main};
  background: linear-gradient(
    180deg,
    ${themeStyles.colors.white.main}00 0px,
    ${themeStyles.colors.darkGreys[4].main}99 ${parseInt(fadeSize) / 2}em,
    ${themeStyles.colors.darkGreys[4].main}FF ${fadeSize},
    ${themeStyles.colors.darkGreys[4].main}FF 100%
  );
`

export const StyledSlideImg = styled.div`
  width: 100%;
  position: relative;
  padding-top: 40%;

  img {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const iconSize = '2em'
export const StyledIcon = styled.img`
  width: ${iconSize};
  height: ${iconSize};
  object-fit: cover;
  padding: 0.25em;
`

export const StyledText = styled.div`
  display: flex;

  font-weight: ${brandConfig.fonts.text.paragraph.weight};
  font-size: ${brandConfig.fonts.text.paragraph.size.mobile};
  align-items: center;
  justify-content: center;
`
